.appBar {
  position: absolute;
  /* top: var(--app-dev-banner-h, 0); */
  left: 0;
  right: 0;
  z-index: 1100;
}

:global(:root[data-dev='true']) {
  /**
   * Banner is 24px tall in dev mode (main.tsx sets `data-dev='true'`).
   * Both the banner (dev-banner.module.css) and the chrome
   * (app-chrome.tsx) read this var to size themselves / reserve space.
   * If this is 0px the banner has zero height and disappears entirely.
   */
  --app-dev-banner-h: 24px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  /* Opaque: content scrolling under the bar must not show through. --tuna-palette-layers is translucent. */
  background-color: var(--tuna-surface-default);
  border-bottom: 1px solid var(--tuna-palette-divider);
  box-sizing: border-box;
  z-index: 1;
  color: var(--tuna-palette-text-secondary);
  height: 48px;
  gap: 8px;
  align-items: center;
  padding: 0 8px;
  overflow: hidden;
}

.backButton {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  min-width: 32px;
  flex-shrink: 0;
}

/* Small screens: a 44 × 44 touch target (the icon stays the same size) */
@media (max-width: 899.95px) {
  .backButton {
    min-width: 44px;
    min-height: 44px;
  }
}

.placeholder {
  width: 32px;
  flex-shrink: 0;
}

/*
 * The breadcrumb slot never shrinks below the mobile "Show path" button (small IconButton: 24px icon +
 * 2 × 5px padding). When the toolbar is too narrow, the right-side actions overflow instead.
 */
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
  flex: 1;
  min-width: 34px;
  overflow: hidden;
}
